export function getSaveAsNewUrl(state) {
    return state.saveAsNewUrl
}

export function getCurrentYear(state) {
    return parseInt(state.currentYear)
}

export function getStartDate(state) {
    return state.startDate
}

export function getEndDate(state) {
    return state.endDate
}


